export const language = {
    "Custom Design": "Custom Design",
    "Cancel": "Cancel",
    "Update": "Update",
    "Save": "Save",
}